import { useCallback, useEffect } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { ExternalLinkIcon } from 'foundations-assets';
import { Hoverlay } from 'foundations-components/transitional/components/Hoverlay';
import { Image } from 'foundations-components/transitional/components/Image';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
// @ts-expect-error Untyped import
import QuestionAnswerList from './QuestionAnswerList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Question = ({
  answers,
  id,
  image,
  imageAlt,
  onSelectAnswer,
  selectedAnswerIds,
  type
}) => {
  const handleSelectAnswer = useCallback(answerId => {
    if (type === 'MULTIPLE_CHOICE_SELECT_MANY') {
      return onSelectAnswer(selectedAnswerIds.includes(answerId) ? selectedAnswerIds.filter(selectedId => selectedId !== answerId) : [...selectedAnswerIds, answerId]);
    }
    return onSelectAnswer([answerId]);
  }, [onSelectAnswer, selectedAnswerIds, type]);
  useEffect(() => {
    const handleKeydown = event => {
      const pressedNumber = parseInt(event.key, 10);
      if (answers.length < 10 && !isNaN(pressedNumber)) {
        const selectedAnswer = answers[pressedNumber - 1];
        if (selectedAnswer) {
          handleSelectAnswer(selectedAnswer.id);
        }
      }
    };
    document.addEventListener('keydown', handleKeydown);
    return () => document.removeEventListener('keydown', handleKeydown);
  }, [answers, handleSelectAnswer]);
  return /*#__PURE__*/_jsxs("div", {
    children: [image &&
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(Hoverlay, {
      foregroundContent: /*#__PURE__*/_jsx(Clickable, {
        onClick: () => window.open(image, '_blank'),
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          alignSelf: "center",
          blockSize: "100%",
          flexDirection: "column",
          justifyContent: "center",
          children: [/*#__PURE__*/_jsx("h2", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.quiz.openImage"
            })
          }), /*#__PURE__*/_jsx(ExternalLinkIcon, {
            size: "1000"
          })]
        })
      }),
      marginBlock: "800",
      children: /*#__PURE__*/_jsx(Image, {
        alt: imageAlt || I18n.text('learningCenter.quiz.image'),
        "data-test-id": "quiz-question-image",
        src: image
      })
    }), /*#__PURE__*/_jsx(QuestionAnswerList, {
      answers: answers,
      multipleSelection: type === 'MULTIPLE_CHOICE_SELECT_MANY',
      onSelectAnswer: handleSelectAnswer,
      questionId: id,
      selectedAnswerIds: selectedAnswerIds
    })]
  });
};
export default Question;